import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent } from 'devextreme-angular';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { SeguimientoService } from 'src/app/services/formulacion/seguimiento.service';
import { PoaTechoService } from 'src/app/services/service.index';

declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-lista-reportados',
  templateUrl: './lista-reportados.component.html',
  styles: []
})
export class ListaReportadosComponent implements OnInit {
  dataResourceAgregacion: any;
  mes_id: number = 0;
  meses: any = [];
  techos: any[];
  oTechos: any[];
  baseUrl = environment.apiEndpoint;
  techoId: number;
  popupVisibleEstado: boolean = false;
  popupVisibleO: boolean = false;
  rol: number = 0;
  gestion_id: number = 0;
  tipo_agregacion_id: number = 1;;
  constructor(private _gs: GeneralService, private _ss: SeguimientoService, private _ts: PoaTechoService) {

    let u = JSON.parse(localStorage.getItem('u'));
    if (u != null) {
      this.rol = u.rol;
      this.gestion_id = u.gestion_id;
      this.tipo_agregacion_id = 1;

      this.getListaMeses();
      this.getTechoByUO(this.tipo_agregacion_id);
      this.getTipoAgregacion();
      this.getMesAreportar();
    }
  }

  ngOnInit() {
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
    });
  }

  getMesElegido(e: any) {
    if (e.value != undefined && e.value != null) {
      this.mes_id = e.value
    }
  }

  getTipoAgregacion() {
    this._ts.getTipoAgregacion().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceAgregacion = result.data;
        } else {
          this.dataResourceAgregacion = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  refreshDataGridTipo(e) {
    this.tipo_agregacion_id = e.value;
    this.getTechoByUO(this.tipo_agregacion_id);
    //this.dataGrid.instance.refresh();
  }

  getListaMeses() {
    this._ss.getListaMeses().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.meses = result.data;
        }
        else { this.meses = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getTechoByUO(id: number) {
    let u = JSON.parse(localStorage.getItem('u'));
    if (u != null) {
      this._gs.getTechoByUOByTipoAgregacion(id, this.tipo_agregacion_id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.techos = result.data;
          } else {
            this.techos = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  showModalEnviarRevision(id: number) {
    this.techoId = id;
    this.popupVisibleEstado = true;
  }

  getMesAreportar() {
    this._ss.getMesDeReporte().subscribe(
      (Response) => {
        let result = UtilHelper.responses(Response);
        if (result.status == 200) {
          this.mes_id = parseInt(result.data.id);
        }
      }
    );
  }

  enviarRevision() {
    this._gs.updateEstadoTecho({ id: this.techoId }).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleEstado = false;
          toastr.success('Operación realizada exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalObs(id: number) {
    this._gs.getObservacionesTecho(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.oTechos = result.data;
        } else {
          this.oTechos = [];
        }
      });
    this.popupVisibleO = true;
  }
}

